import { render } from "./CreateCustomer.vue?vue&type=template&id=902a0aa8&scoped=true&ts=true"
import script from "./CreateCustomer.vue?vue&type=script&lang=ts"
export * from "./CreateCustomer.vue?vue&type=script&lang=ts"

import "./CreateCustomer.vue?vue&type=style&index=0&id=902a0aa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902a0aa8"]])

export default __exports__